import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getAvaiedServicesAPI = createAsyncThunk(
    "getAvaiedServicesAPI",
    async (data, { rejectWithValue }) => {
        const id = data?.id;
        const page = data?.page
        try {
            const response = await api.get(endpoints.getAvailedServices(id, page));
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const getAvaiedServicesDetailAPI = createAsyncThunk(
    "getAvaiedServicesDetailAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAvailedServiceDetail(id));
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const sendFeedbackAPI = createAsyncThunk(
    "sendFeedbackAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.sendFeedback(), data);
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

const initialState = {
    loading: false,
    feedBackLoading: false,
    requestDetail: "",
    availedServices: [],
    pagination: {
        current_page: 1,
        total_pages: 1,
    },
}

const availedServiceSlice = createSlice({
    initialState,
    name: "availedServiceSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAvaiedServicesAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(getAvaiedServicesAPI.fulfilled, (state, action) => {
            state.loading = false
            state.availedServices = action.payload.data.data.data;
            state.pagination = {
                current_page: action.payload.data.data.current_page,
                total_pages: action.payload.data.data.last_page,
            };
        })

        builder.addCase(getAvaiedServicesAPI.rejected, (state, action) => {
            state.loading = false
        })

        // AVAILED SERVICE DETAIL

        builder.addCase(getAvaiedServicesDetailAPI.pending, (state, action) => {
            state.detailLoading = true
        })

        builder.addCase(getAvaiedServicesDetailAPI.fulfilled, (state, action) => {
            state.detailLoading = false
            state.requestDetail = action?.payload?.data?.data
        })

        builder.addCase(getAvaiedServicesDetailAPI.rejected, (state, action) => {
            state.detailLoading = false
        })

        // SEND FEEDBACK DETIAL HERE

        builder.addCase(sendFeedbackAPI.pending, (state, action) => {
            state.feedBackLoading = true
        })

        builder.addCase(sendFeedbackAPI.fulfilled, (state, action) => {
            state.feedBackLoading = false
        })

        builder.addCase(sendFeedbackAPI.rejected, (state, action) => {
            state.feedBackLoading = false
        })
    }
})

export const { } = availedServiceSlice.actions
export default availedServiceSlice.reducer